import { useMemo } from "react";

/** Layout baseline at browser zoom 100%. */
export const KANBAN_LAYOUT_BASE_ZOOM_PERCENT = 100;

/** Minimum column width at 100% zoom; columns grow with `1fr` to fill the board. */
export const KANBAN_COLUMN_WIDTH_PX = 300;

export const KANBAN_CARD_MIN_HEIGHT_PX = 88;

export const KANBAN_COLUMN_GAP_PX = 16;

export function buildKanbanGridTemplateColumns(columnCount) {
  const count = Math.max(0, Number(columnCount) || 0);
  if (count === 0) return "none";
  return `repeat(${count}, minmax(${KANBAN_COLUMN_WIDTH_PX}px, 1fr))`;
}

export function buildKanbanBoardLayoutStyle() {
  return {
    "--kanban-column-min-width": `${KANBAN_COLUMN_WIDTH_PX}px`,
    "--kanban-card-min-height": `${KANBAN_CARD_MIN_HEIGHT_PX}px`,
    "--kanban-column-gap": `${KANBAN_COLUMN_GAP_PX}px`,
  };
}

/**
 * Fluid Kanban grid: min column width at 100% zoom, columns expand to fill viewport width.
 */
export function useKanbanBoardLayout(columnCount = 0) {
  const gridTemplateColumns = useMemo(
    () => buildKanbanGridTemplateColumns(columnCount),
    [columnCount]
  );

  const boardStyle = useMemo(() => buildKanbanBoardLayoutStyle(), []);

  return {
    gridTemplateColumns,
    boardStyle,
    columnMinWidthPx: KANBAN_COLUMN_WIDTH_PX,
  };
}
